import {DriveRevision} from '../drive/types';

/** How many versions the panel lists until "show all" is clicked. */
export const DEFAULT_VISIBLE_REVISIONS = 3;

export interface NumberedRevision {
    revision: DriveRevision;
    /** 1 for the oldest kept version, counting up to the current one. */
    number: number;
    /** The current content of the file (the newest version). */
    latest: boolean;
}

function timeOf(revision: DriveRevision): number {
    const time = Date.parse(revision.modifiedTime);
    return Number.isNaN(time) ? 0 : time;
}

/**
 * The versions newest first, numbered chronologically. Drive lists them oldest first; they are
 * sorted by time anyway, keeping Drive's order for equal times.
 */
export function numberRevisions(revisions: DriveRevision[] | undefined): NumberedRevision[] {
    if (!revisions || revisions.length === 0) return [];
    /*const chronological = revisions
        .map((revision, index) => ({revision, index}))
        .sort((a, b) => timeOf(a.revision) - timeOf(b.revision) || a.index - b.index)
        .map(({revision}) => revision);*/
    return revisions
        .map((revision, i) => ({revision, number: i + 1, latest: i === revisions.length - 1}))
        .reverse();
}

/** The versions to list: the newest few, or all of them once expanded. */
export function visibleRevisions(revisions: NumberedRevision[], expanded: boolean): NumberedRevision[] {
    return expanded ? revisions : revisions.slice(0, DEFAULT_VISIBLE_REVISIONS);
}

/**
 * The version to show of a file: an older one picked in the panel, or undefined for the current
 * content (also when the pick is the newest version, or no longer listed).
 */
export function selectedOlderRevision(
    revisions: NumberedRevision[],
    revisionId: string | undefined,
): NumberedRevision | undefined {
    if (!revisionId) return undefined;
    const found = revisions.find((r) => r.revision.id === revisionId);
    return found && !found.latest ? found : undefined;
}
